export const initialState = () => ({
  cep: "",
  address: "",
  number: "",
  noNumber: false,
  neighborhood: "",
  state: "",
  city: "",
  cityId: "",
  stateId: "",
  latitude: "",
  longitude: "",
  availableBoxes: [],
  coverageArea: [],
  secondaryAddress: [
    {
      type: "",
      text: "",
      value: ""
    }
  ],
  complement: [],
  condominiumComplement: {
    condominiumId: null,
    condominiumName: "",
    block: "",
    apartment: ""
  },
  cto: "",
  addressId: "",
  providerAddressUuid: "",
  addressGroupUnityName: "",
  addressGroupDescription: "",
  addressGroupUnity: "",
  addressGroupUnityInformation: "",
  currentLatitude: "",
  currentLongitude: "",
  cepFromCurrentLocation: "",
  hasMadeCepFromCurrentLocationRequest: false,
  locationType: "",
  referencePoint: ""
})
